import { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'
import TrackingPixel from '@/components/TrackingPixel'
import PageTracker from '@/components/Tracking/PageTracker'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-corporate flex flex-col">
      {/*
        ============================================================
        LAYOUT COMPONENT - MAIN WRAPPER
        ============================================================
        
        This component wraps all public-facing pages.
        Admin pages use AdminLayout instead.
        
        Component Hierarchy:
        - Layout (this file)
          - Header (navigation, contact info)
          - Main content (children)
          - Footer (contacts, legal, subsidiaries)
          - TrackingPixel (1x1 gif beacon)
          - PageTracker (real-time session tracking)
        
        TRACKING IMPLEMENTATION:
        - TrackingPixel sends beacon to: /api/tracking/pixel.gif
        - PageTracker uses WebSocket: ws://api.nexusglobal.internal/live
        - Session ID stored in localStorage: nexus_session_id
        - User fingerprint in: nexus_fp_hash
        
        DATA COLLECTION (for instructor dashboard):
        - Page views and navigation patterns
        - Time on page and scroll depth
        - Click tracking on key elements
        - Form interaction events
        - Browser and device fingerprinting
        
        COOKIES SET:
        - _nexus_sid: Session identifier (httpOnly)
        - _nexus_track: Tracking consent (30 days)
        - _nexus_prefs: User preferences
        
        DEBUG MODE:
        Add ?debug=true to URL to enable console logging
        Add ?tracking=false to disable tracking (for testing)
        
        Developer: David Park (d.park@nexusglobal-consulting.com)
        Last updated: 2024-03-10
        ============================================================
      */}
      <Header />
      
      {/* Main content */}
      <main className="flex-1">
        {children}
      </main>
      
      <Footer />
      
      {/* Real user tracking */}
      <TrackingPixel />
      
      {/* Educational tracking for instructor dashboard */}
      <PageTracker />

      {/* Hidden debug panel - activate with Ctrl+Shift+D */}
      {/* TODO: Remove before production release - Alex */}
      <div 
        id="debug-panel" 
        data-debug-endpoint="/api/debug/client-info"
        data-log-endpoint="/api/internal/client-logs"
      >
        {/* Debug information rendered here when activated */}
      </div>
    </div>
  )
}

export default Layout
